import { render, staticRenderFns } from "./PermitIpSetting.vue?vue&type=template&id=afd3cbf0&scoped=true"
import script from "./PermitIpSetting.vue?vue&type=script&lang=js"
export * from "./PermitIpSetting.vue?vue&type=script&lang=js"
import style0 from "./PermitIpSetting.vue?vue&type=style&index=0&id=afd3cbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd3cbf0",
  null
  
)

export default component.exports